module.exports = __webpack_public_path__ + "img/board-100.93239b66.png";